var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-download" }, [
    _vm.isMobile
      ? _c("div", { staticClass: "app" }, [
          _vm._m(0),
          _vm._m(1),
          !_vm.disabledBtn
            ? _c("button", { staticClass: "btn" }, [
                _vm.isIOS
                  ? _c(
                      "a",
                      { attrs: { href: _vm.appStoreUrl, target: "_blank" } },
                      [_vm._v("立刻下载")]
                    )
                  : _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.isAndroidUrl,
                          disabled: _vm.disabledBtn,
                          target: "_blank",
                        },
                      },
                      [_vm._v("立刻下载")]
                    ),
              ])
            : _c(
                "button",
                {
                  staticClass: "btn btn-disabled",
                  attrs: { disabled: _vm.disabledBtn },
                },
                [_vm._v("立刻下载")]
              ),
        ])
      : _vm._e(),
    _vm._m(2),
    _vm.isWeChatBrowser
      ? _c(
          "div",
          { staticClass: "wechat-masking", on: { click: _vm.closePrompt } },
          [
            _c(
              "div",
              {
                staticClass: "wechat",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                  },
                },
              },
              [
                _c("div", { staticClass: "prompt" }, [_vm._v("温馨提示：")]),
                _vm._m(3),
                _c(
                  "div",
                  { staticClass: "close-btn", on: { click: _vm.closePrompt } },
                  [_vm._v("关闭")]
                ),
              ]
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "img-logo" }, [
      _c("img", {
        attrs: { src: require("../../../public/img/app-login.png"), alt: "" },
      }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "box" }, [
      _c("p", { staticClass: "title" }, [_vm._v("App简介")]),
      _c("p", { staticClass: "des" }, [
        _vm._v(
          "米立智能App是一个智能设备管理工具，通过米立智能APP，你可以控制家中的智能设备，使用场景，家庭管理等功能服务，体验智能生活。"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pc", attrs: { else: "" } }, [
      _c("div", { staticClass: "pc-box" }, [
        _c("div", { staticClass: "qr-code", attrs: { id: "qrcode" } }),
        _c("p", { staticClass: "pc-des" }, [
          _vm._v("请使用手机微信、相机或者浏览器扫描米立智能App"),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("p", [_vm._v("1、点击右上角菜单")]),
      _c("p", [_vm._v("2、选择【在浏览器打开】")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }